export default __webpack_public_path__ + "static/media/Background_00144.4fa68a7a.png";